import { render } from "./CreateOrganization.vue?vue&type=template&id=7fbbf70e"
import script from "./CreateOrganization.vue?vue&type=script&lang=js"
export * from "./CreateOrganization.vue?vue&type=script&lang=js"

import exportComponent from "/home/github-runner/actions-runner/_work/acutame/acutame/src/main/front/merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__